import { GeneratedTemplateType } from "../../../types/util-types";

const VerticalFeatureBlockStore = {
    [GeneratedTemplateType.CONTRACT]: {
        title: 'verticalFeaturesBlock.title',
        subtitle: 'verticalFeaturesBlock.subtitle',
        gridItems: [
            {
                customClass: 'vertical-feature-block__grid-item-content--business-management',
                transId: 'verticalFeaturesBlock.featureGrid.businessManagement',
                imagePath: 'marketing_site/ai_templates/Subtract.png',
            },
            {
                customClass: 'vertical-feature-block__grid-item-content--automations',
                transId: 'verticalFeaturesBlock.featureGrid.automations',
                imagePath: 'marketing_site/ai_templates/Frame_1000001596.png',
            },
            {
                customClass: 'vertical-feature-block__grid-item-content--finances',
                transId: 'verticalFeaturesBlock.featureGrid.finances',
                imagePath: 'marketing_site/ai_templates/Group_1000002254.png',
            },
            {
                customClass: 'vertical-feature-block__grid-item-content--collaboration',
                transId: 'verticalFeaturesBlock.featureGrid.collaboration',
                imagePath: 'marketing_site/ai_templates/Frame_1073713849.png',
            },
            {
                customClass: 'vertical-feature-block__grid-item-content--online-payments',
                transId: 'verticalFeaturesBlock.featureGrid.onlinePayments',
                imagePath: 'marketing_site/ai_templates/Frame_48096198.png',
            },
            {
                customClass: 'vertical-feature-block__grid-item-content--scheduling',
                transId: 'verticalFeaturesBlock.featureGrid.scheduling',
                imagePath: 'marketing_site/ai_templates/Group_48096347.png',
            }
        ]
    }
};

export default VerticalFeatureBlockStore;
